import { IRadioOption } from 'app/interfaces/IRadioOption';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AuthConstants } from 'app/services/authentication/auth-constants';

import { Constants } from '../shared-constants';

export const atlasConnectionString = 'mongodb+srv://[username:password@][clusterName.][randomString.]host[/[database][?options]]';
export const cosmosMongoDomain: string = AuthConstants.RESOURCE_DOMAIN_MAP[adfModelTypeMap.cosmosMongo.linkedServiceType];
export const oldCosmosMongoString = 'mongodb://<account>:<password>@<account>.documents.azure.com:10255[?options]';
export const newCosmosMongoString = 'mongodb://<account>:<password>@<account>.mongo.cosmos.azure.com:10255[?options]';
export const server32Options: Array<IRadioOption<boolean>> = [
    {
        label: stringResources.CosmosMongoServerAbove32,
        value: true
    },
    {
        label: '3.2',
        value: false
    }
];

export enum mongoDbDriverVersion {
    V2 = 'v2',
    V1 = 'v1'
}

export const mongoDbDriverVersionOptions: Array<IRadioOption<string>> = [
    {
        label: mongoDbDriverVersion.V2,
        value: mongoDbDriverVersion.V2
    },
    {
        label: mongoDbDriverVersion.V1,
        value: mongoDbDriverVersion.V1
    }
];

export const connectionString = 'mongodb://[username:password@]host[:port][/[database][?options]]';
export const keyVaultDomain = AuthConstants.RESOURCE_DOMAIN_MAP[adfModelTypeMap.azureKeyVault.linkedServiceType];

export const powerBIDocLink = 'https://docs.microsoft.com/azure/synapse-analytics/quickstart-power-bi';

export const salesforceMarketingCloudReservedKeys: string[] = ['host', 'authenticationType', 'clientId', 'clientSecret', 'useEncryptedEndpoints', 'useHostVerification', 'usePeerVerification', 'encryptedCredential'];

export const xeroReservedKeys: string[] = ['host', 'authenticationType', 'consumerKey', 'privateKey', 'useEncryptedEndpoints', 'useHostVerification', 'usePeerVerification', 'tenantId', 'refreshToken', 'encryptedCredential'];

export const zendeskEntityOptions = {
    ACTIVITIES: 'activities',
    GROUPS: 'groups',
    GROUP_MEMBERSHIPS: 'group_memberships',
    ORGANIZATIONS: 'organizations',
    REQUESTS: 'requests',
    SATISFACTION_RATINGS: 'satisfaction_ratings',
    SESSIONS: 'sessions',
    TAGS: 'tags',
    TARGETS: 'targets',
    TICKETS: 'tickets',
    TICKET_AUDITS: 'ticket_audits',
    TICKET_FIELDS: 'ticket_fields',
    TICKET_METRICS: 'ticket_metrics',
    TRIGGERS: 'triggers',
    USERS: 'users',
    VIEWS: 'views'
} as const;

export const zohoReservedKeys: string[] = [
    'endpoint', 'accessToken', 'authenticationType', 'clientId', 'clientSecret', 'refreshToken',
    'useEncryptedEndpoints', 'useHostVerification', 'usePeerVerification', 'encryptedCredential', 'accountsUrl'
];

export const azureSearchDomain: string = AuthConstants.RESOURCE_DOMAIN_MAP[adfModelTypeMap.azureSearch.linkedServiceType];

export const azureSqlDomain: string = AuthConstants.RESOURCE_DOMAIN_MAP[adfModelTypeMap.azureSql.linkedServiceType];
export const sqlPEWellknownErrorMessages: RegExp[] = [
    /The public data endpoint on this server is not accessible. To connect to this server, use the Private Endpoint from inside your virtual network/i,
    /Client with IP address .* is not allowed to access the server/i,
    /make sure the SQL Database firewall/i,
    /Verify that the instance name is correct and that SQL Server is configured to allow remote connections/i
];

export const storagePEWellknownErrorMessages: RegExp[] =
    [
        /This request is not authorized to perform this operation/i,
        /Unable to connect to the remote server/i,
        /A connection attempt failed because the connected party did not properly respond after a period of time/i,
        /The remote name could not be resolved/i
    ];

export const concurReservedKeys: string[] = ['host', 'authenticationType', 'baseUrl', 'clientId', 'clientSecret', 'username', 'password', 'useEncryptedEndpoints', 'useHostVerification', 'usePeerVerification', 'encryptedCredential'];

export const cosmosDocumentDomain: string = AuthConstants.RESOURCE_DOMAIN_MAP[adfModelTypeMap.cosmosSql.linkedServiceType];

export const cosmosDBPEWellknownErrorMessages: RegExp[] = [
    /This is blocked by your Cosmos DB account firewall settings/i
];

export const googleAdwordsReservedKeys = [
    'clientCustomerID', 'developerToken', 'authenticationType', 'clientId', 'clientSecret', 'refreshToken',
    'email', 'keyFilePath', 'trustedCertPath', 'useSystemTrustStore', 'loginCustomerID', 'encryptedCredential', 'supportLegacyDataTypes',
    'googleAdsApiVersion', 'privateKey'
];

export const blobPathRegex = {
    pattern: Constants.blobContainerNameValidation,
    message: stringResources.CopyWizard_Dataset_Blob_Sink_ContainerValidationError
};

export const workdayEndpoints = {
    Human_Resources: ['Get_Change_Government_IDs', 'Get_Change_Other_IDs', 'Get_Change_Passports_and_Visas', 'Get_Change_Personal_Information', 'Get_Change_Preferred_Name', 'Get_Change_Work_Contact_Information',
        'Get_Committee_Classification_Groups', 'Get_Committee_Classifications', 'Get_Committee_Definition', 'Get_Committee_Meetings', 'Get_Committee_Membership_Types', 'Get_Company_Insider_Types', 'Get_Difficulty_to_Fill',
        'Get_Disabilities', 'Get_Disability_Configuration', 'Get_Establishments', 'Get_Ethnicities', 'Get_External_Form_I-9', 'Get_External_Form_I-9_Section_3', 'Get_Former_Worker_Documents', 'Get_Former_Workers', 'Get_Frequencies',
        'Get_Gender_Identities', 'Get_Holiday_Calendars', 'Get_Job_Categories', 'Get_Job_Classification_Groups', 'Get_Job_Families', 'Get_Job_Family_Groups', 'Get_Job_Profiles', 'Get_LGBT_Identifications', 'Get_Location_Attributes',
        'Get_Locations', 'Get_Organizations', 'Get_Organization_Reference_IDs', 'Get_Organizations_Names', 'Get_Personal_Information_Help_Text', 'Get_Political_Affiliations', 'Get_Preferred_Communication_Language', 'Get_Previous_System_Job_History',
        'Get_Pronouns', 'Get_Provisioning_Groups', 'Get_Provisioning_Group_Assignments', 'Get_Race_Ethnicity_Details', 'Get_Service_Center_Representative_Workday_Accounts', 'Get_Service_Center_Representatives', 'Get_Sexual_Orientations',
        'Get_Social_Benefits_Localities', 'Get_Sort_Order_Enableds', 'Get_Supervisory_Organization_Assignment_Restrictions', 'Get_Training_Types', 'Get_User-Based_Security_Group_Assignments', 'Get_Work_Schedule_Calendar_Groups', 'Get_Work_Shifts',
        'Get_Worker_Start_Date_Correction_Defaulting_Rules', 'Get_Workers']
} as const;

export const workdayVersions: string[] = [
    'v9', 'v10', 'v11', 'v12', 'v13', 'v14', 'v15', 'v16', 'v17', 'v18', 'v19', 'v20', 'v21.0', 'v21.1',
    'v22.0', 'v22.1', 'v23.0', 'v23.1', 'v23.2', 'v24.0', 'v24.1', 'v24.2', 'v25.0', 'v25.1', 'v25.2',
    'v26.0', 'v26.1', 'v26.2', 'v27.0', 'v27.1', 'v27.2', 'v28.0', 'v28.1', 'v28.2', 'v29.0', 'v29.1',
    'v29.2', 'v30.0', 'v30.1', 'v30.2', 'v31.0', 'v31.1', 'v31.2', 'v32.0', 'v32.1', 'v32.2', 'v33.0',
    'v33.1', 'v33.2', 'v34.0', 'v34.1', 'v34.2', 'v35.0', 'v35.1', 'v35.2', 'v36.0', 'v36.1', 'v36.2',
    'v37.0', 'v37.1', 'v37.2', 'v38.0', 'v38.1', 'v38.2', 'v39.0', 'v39.1'
];
